import { NotificationIdentifierModel } from '../../models/low-level/notification-identifier.model';
import { NotificationIdState } from './notification-id.type';

export class NotificationStateUtilities {
    /**
     * Projects the class-based identifier into its plain state shape, so it can be
     * carried by actions and stored without tripping the store's serializability checks.
     * Spreading the model is not an option: `frontId`, `qmNum` and `maNum` are prototype
     * getters and would be dropped, leaving only the inner `TextModel` instances behind.
     */
    public static toState(identifier: NotificationIdentifierModel): NotificationIdState {
        return {
            frontId: identifier.frontId,
            qmNum: identifier.qmNum,
            maNum: identifier.maNum,
        };
    }

    public static compare(a: NotificationIdState, b: NotificationIdState): boolean {
        return a.frontId === b.frontId && a.qmNum === b.qmNum && a.maNum === b.maNum;
    }

    public static notificationIdToString(notificationId: NotificationIdState): string {
        return notificationId.frontId + ':' + notificationId.qmNum + ':' + notificationId.maNum;
    }
}
